<template>
  <DatePicker
    transfer
    confirm
    type="datetimerange"
    format="yyyy-MM-dd"
    :placeholder="placeholder"
    @on-change="change_times"
    @on-ok="change_value"
  ></DatePicker>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择时间"
    },
    param: {
      type: Object,
      default: () => {
        return {
          filter: "a.verifytime",
          op: "BETWEEN"
        };
      }
    }
  },
  data() {
    return {
      times: ""
    };
  },
  methods: {
    change_times(val) {
      this.times = val;
    },
    change_value() {
      let params = getParams(this.param.filter, this.times, this.param.op);
      console.log(params);
      this.$emit("get", params, Boolean(this.times));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseTime.vue